import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TypeaheadBase} from '../../../common/typeahead/typeahead-base';

@Component({
  selector: 'app-invoice-form-so-po',
  templateUrl: './invoice-form-so-po.component.html',
  standalone: false
})
export class InvoiceFormSoPoComponent extends TypeaheadBase {
  @Input() vm: any;
  @Input() canGenerateShipment = false;
  @Input() canGenerateInvoice = false;
  @Input() headerId?: number | string;
  // Rendering controls
  @Input() showActions = true;
  @Input() showHeader = false;
  @Input() submitted = false;
  @Input() showEntity = false;
  @Input() showAddressContact = false;

  @Output() generateShipment = new EventEmitter<void>();
  @Output() generateInvoice = new EventEmitter<void>();
  @Output() clearEntity = new EventEmitter<void>();

  entityTypeaheadSearch = (text$: any) => this.typeaheadSearch(text$, () => this.vm?.entityName, 15);

  // Local helper mirrors parent utility
  isFieldEmpty(val: any): boolean {
    if (val === null || val === undefined) {
      return true;
    }
    if (typeof val === 'string') {
      return val.trim().length === 0;
    }
    return false;
  }
}
